import { defineMessage, useIntl } from 'react-intl';

const title = defineMessage({
  id: 'slot.payback.label',
  defaultMessage: 'PAYBACK',
});

export const usePaybackLink = () => {
  const { formatMessage } = useIntl();

  return {
    href: '/service-hilfe/bestellen-beraten/payback',
    label: formatMessage(title),
  };
};
